import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", testid }) => (
  <motion.div
    data-testid={testid}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, children, light = false }) => (
  <p
    className={`text-[11px] font-medium uppercase tracking-[0.3em] ${
      light ? "text-paper/60" : "text-navy/70"
    }`}
  >
    <span className="text-navy">{index}</span>
    {children ? ` · ${children}` : ""}
  </p>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`mask-line ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
